module.exports = __webpack_public_path__ + "static/media/206-Telefonat_ID_17m.8f22bb7b.mp3";